import React from 'react';
import CityPage from '../CityPage/CityPage';
import image from './ottawa.jpeg';

const OttawaPage = () => (
  <CityPage
    city="Ottawa"
    region="Ontario"
    country="Canada"
    countryCode="CA"
    routePath="/Ottawa"
    currentPage="OttawaPage"
    image={image}
    imageAlt="Boat rentals on the Ottawa River and Rideau Canal"
    intro="Ottawa is Canada's capital and one of the best cities in eastern Ontario for time on the water. With the Ottawa River, the Rideau Canal and a string of lakes within easy reach, WetRentals connects you directly with local boat owners offering Sea-Doos, pontoons, fishing boats, wake boats and more."
    sections={[
      {
        heading: 'Where to boat near Ottawa',
        body:
          "Popular launches include Britannia Bay, Petrie Island, the Rideau River, Pink Lake and Meech Lake in nearby Gatineau Park, and the upper Rideau system stretching toward Westport and Kingston. WetRentals hosts can deliver to docks or launches across the National Capital Region.",
      },
      {
        heading: 'What you can rent in Ottawa',
        body:
          'Sea-Doo and Jet Ski rentals, pontoon boats for family days and parties, fishing boats for walleye and bass on the Ottawa River, wake and ski boats, plus kayaks, canoes and paddleboards for the Rideau Canal and quieter inland lakes.',
      },
      {
        heading: 'Why book with WetRentals in Ottawa',
        body:
          "WetRentals started in Ottawa and is now Canada's largest peer-to-peer boat rental platform. Every booking includes safety equipment, instant confirmation, host messaging and a flexible cancellation policy.",
      },
    ]}
    searchUrl="/s?address=Ottawa%2C%20ON&bounds=45.91160004%2C-74.97675966%2C44.69469707%2C-76.37807719"
    searchLabel="Browse all boat rentals in Ottawa"
    showMembershipBanner
  />
);

export default OttawaPage;
